import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface PlatformMarkup {
  platform: string;
  markup: number;
}

export interface Markup {
  platform: string;
  markup: number;
  listing_id: string;
}

export interface PricePreview {
  label: string;
  platform: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class MarkupsService {
  constructor(private readonly http: HttpClient) {}

  getPlatformMarkups(): Observable<PlatformMarkup[]> {
    return this.http.get(`${environment.apiUrl}/markups`).pipe(
      map((res: { data: PlatformMarkup[] }) => {
        return res.data;
      })
    );
  }

  updatePlatformMarkups(payload: PlatformMarkup[]): Observable<any> {
    return this.http.post(`${environment.apiUrl}/markups`, { markups: payload }).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getPropertyMarkups(propertyId: string): Observable<Markup[]> {
    return this.http.get(`${environment.apiUrl}/markups/properties/${propertyId}`).pipe(
      map((res: { data: Markup[] }) => {
        return res.data;
      })
    );
  }

  updatePropertyMarkups(propertyId: string, payload: Markup): Observable<any> {
    return this.http
      .post(`${environment.apiUrl}/markups/properties/${propertyId}`, {
        markups: [payload],
      })
      .pipe(
        map((res) => {
          res;
        })
      );
  }

  getPerPlatformPricePreviews(propertyId: string, basePrice: string): Observable<PricePreview[]> {
    const payload = {
      price: basePrice,
    };

    return this.http.post(`${environment.apiUrl}/markups/properties/${propertyId}/markup`, payload).pipe(
      map((res: { data: PricePreview[] }) => {
        return res.data;
      })
    );
  }
}
